// components/TicketsSection.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import cupIllustration from "../../assets/cup-illustration.png";
import person from "../../assets/person.png";

const tiers = [
  // {
  //   slug: "early-bird",
  //   name: "Early Bird",
  //   price: "£75",
  //   description: "Limited-time offer for early bookings.",
  //   features: [
  //     "General Admission",
  //     "Welcome Drink",
  //     "Access to Evening Showcase",
  //   ],
  //   color: "#B9A68D",
  //   highlighted: false,
  // },
  // {
  //   slug: "standard",
  //   name: "Standard",
  //   price: "£100",
  //   description: "Full event access with standard perks.",
  //   features: ["General Admission", "Evening Showcase", "Light Refreshments"],
  //   color: "#B9A68D",
  //   highlighted: false,
  // },
  {
    slug: "final-release",
    name: "Final Release Ticket",
    price: "£130",
    description: "Exclusive benefits for a premium evening.",
    features: ["Welcome Drink", "Five-course Dinner With Hosted Pairings"],
    color: "#4E5C36",
    highlighted: true,
  },
];

export default function TicketsSection() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <section className="relative bg-[#E5E4E4] py-28 overflow-hidden">
      {/* Left illustration */}
      <img
        src={person}
        alt="Person Illustration"
        className="absolute top-10 left-0 w-20 md:w-40 lg:w-56 opacity-90"
        data-aos="fade-right"
        data-aos-delay="300"
      />

      {/* Right-bottom illustration */}
      <img
        src={cupIllustration}
        alt="Cup Illustration"
        className="absolute bottom-0 right-0 w-16 md:w-32 lg:w-48 opacity-90"
        data-aos="fade-left"
        data-aos-delay="400"
      />

      {/* Section Header */}
      <div
        className="text-center mb-12 relative z-10 px-6"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <p className="uppercase tracking-widest text-sm text-[#4E5C36]">
          Ticket Prices
        </p>
        <h2 className="text-2xl md:text-4xl font-semibold text-[#4E5C36] mt-2 max-w-2xl mx-auto">
          Here's your experience for a Tailored Taste.
        </h2>
      </div>

      {/* Pricing Cards */}
      <div
        className="container mx-auto px-6 relative z-10"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="flex w-full justify-center">
          {tiers.map((tier, index) => (
            <div
              key={index}
              className={`bg-white shadow-lg rounded-lg text-center w-full max-w-sm transition-transform ${
                tier.highlighted
                  ? "scale-105 border-2 border-[#4E5C36]"
                  : "hover:scale-105"
              }`}
              data-aos="zoom-in-up"
              data-aos-delay={200 * (index + 1)}
            >
              {/* Card top accent */}
              <div
                className="h-2 rounded-t-md"
                style={{ backgroundColor: tier.color }}
              ></div>

              <div className="p-8 flex flex-col justify-between h-full">
                {/* Title */}
                <h3 className="text-lg font-semibold text-[#4E5C36] mb-2">
                  {tier.name}
                </h3>

                {/* Price */}
                <p
                  className="text-3xl font-bold mb-4 favela"
                  style={{ color: tier.color }}
                >
                  {tier.price}
                </p>

                {/* Description */}
                <p className="text-gray-600 mb-6">{tier.description}</p>

                {/* Features */}
                <ul className="space-y-3 mb-6 text-sm text-gray-700 text-left">
                  {tier.features.map((feature, i) => (
                    <li key={i} className="flex gap-2">
                      <span className="text-[#4E5C36] font-semibold">•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <button
                  // onClick={() => navigate(`/tickets/${tier.slug}`)}
                  className="py-2 px-6 rounded font-semibold transition opacity-40"
                  style={{
                    backgroundColor: tier.color,
                    color: tier.color === "#E5E4E4" ? "#4E5C36" : "white",
                  }}
                >
                  Fully Booked
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
